import { useMutation } from 'react-query';
import { network } from 'services/network';
import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

const mutationFn = (params: QueryParams) => {
    return network.post('api/bo/narratives/testNarrativeText', params).then((response) => {
        return response.data;
    });
};
export const useMutationTestNarrativeText = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface QueryParams {
    compareMetaDataId: number;
    actualMetaDataId: number;
    narrativeText: string;
    componentKey: string;
    filter: {
        filters: IFilter[] | undefined;
    };
}
